import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 fade-up" data-testid="payment-cancel-page">
      <div className="card-warm p-8 text-center">
        <div
          className="w-16 h-16 rounded-full grid place-items-center mx-auto mb-4"
          style={{ background: "#FDF0EA" }}
        >
          <XCircle size={32} style={{ color: "#BF5832" }} />
        </div>
        <h1 className="font-serif-display text-3xl font-semibold" style={{ color: "#1C2826" }}>
          Checkout cancelled
        </h1>
        <p className="mt-2 text-sm" style={{ color: "#5C6B66" }}>
          No charge was made. You're still on the free plan.
        </p>
        <div className="flex gap-2 justify-center mt-6">
          <Link to="/pricing">
            <Button className="btn-brand rounded-full h-11 px-6">Back to pricing</Button>
          </Link>
          <Link to="/dashboard">
            <Button variant="outline" className="rounded-full h-11 px-6">
              Go to dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
